export const keyData = [
  {
    id: 1,
    img: require("../../../image/FoodDelivery/key-img-one.webp"),
    title: "Customer App Features",
    content: [
      "User Registration & Profile Management",
      "Search & Filter Options",
      "Real-Time Order Tracking",
      "Multiple Payment Gateways",
      "Push Notifications",
      "Ratings & Reviews",
      "Loyalty Programs & Discounts",
    ],
  },
  {
    id: 2,
    img: require("../../../image/FoodDelivery/key-img-two.webp"),
    title: "Restaurant App Features",
    content: [
      "Restaurant Profile Management",
      "Menu Management",
      "Order Management System",
      "Real-Time Order Notifications",
      "Earnings & Revenue Reports",
      "Customer Support Integration",
    ],
  },
  {
    id: 3,
    img: require("../../../image/FoodDelivery/key-img-three.webp"),
    title: "Delivery Partner App Features",
    content: [
      "Profile & Verification",
      "Live Order Assignments",
      "GPS Navigation & Route Optimization",
      "Earnings & Incentives Dashboard",
      "Order Status Updates",
    ],
  },
  {
    id: 4,
    img: require("../../../image/FoodDelivery/key-img-four.webp"),
    title: "Admin Panel Features",
    content: [
      "Dashboard & Analytics",
      "Restaurant & Delivery Partner Management",
      "Promotions & Discounts Management",
      "Customer Support & Complaint Handling",
      "Revenue & Commission Tracking",
    ],
  },
];
